@if(true){
<div class="w-12 overflow-hidden notification-bar bg-col-w"
     [ngStyle]="{'display': isHidden ? 'none': 'block'}"
     [class.trust-bar-notification-bar]="content.trustpilotLocale && content.trustpilotTemplateId && content.trustpilotBusinessunitId">

    @if (content.trustpilotLocale && content.trustpilotTemplateId && content.trustpilotBusinessunitId) {
    <trustpilot-widget class="w-12 p-t-2 p-t-1-m p-t-1-s p-b-1 p-b-0-m p-b-0-s"
                       [locale]="content.trustpilotLocale"
                       [templateId]="content.trustpilotTemplateId"
                       [businessunitId]="content.trustpilotBusinessunitId"
                       [styleHeight]="'20px'"
                       [styleWidth]="'100%'"
                       [theme]="content.trustpilotTheme" />
    }

    @if(elements?.length){
    @if(!showCarousel) {
    <div [ngStyle]="{'background-color': content?.elements_background_color || ''}">
        <div class="wrap w-12 flex flex-justify-between flex-middle"
             [ngStyle]="{height: (app.client.isM || app.client.isS) ? '36px' : '45px'}">
            @for (item of elements; track item) {
            <div class="flex flex-middle"
                 style="height:100%">
                <p class="center flex flex-justify-center flex-middle va-m">
                    <span class="m-r-1 flex"
                          [style.fontSize.px]="24"
                          [ngClass]="'icon-' + item.icon">
                    </span>
                    <span *iCms="'text' of item"
                          class="c1">
                    </span>
                    <href [link]="item.cta_link">
                        <span class="m-l-2 b-b b-col-b c1 flex flex-middle cursor-pointer"
                              *iCms="'cta_copy' of item"></span>
                    </href>
                </p>
            </div>
            }
        </div>
    </div>
    }
    @if (showCarousel) {
    <ng-container *ngTemplateOutlet="carousel, context: {elements: elements}" />
    }
    }
</div>

<ng-template #carousel
             let-elements="elements">
    <carousel class="pos-relative"
              [autoplay]="{
                delay: content?.slider_animation_delay || 4000,
                disableOnInteraction: false
            }"
              [speed]="content?.slider_animation_speed || 2000"
              [loop]="true"
              [direction]="app.client.isL ? 'horizontal' : 'vertical'"
              [effect]="!app.client.isL ? 'fade' : undefined"
              [slidesPerView]="app.client.isL ? 2 : 1"
              [fadeEffect]="{crossFade: true}"
              [ngStyle]="{height: (app.client.isM || app.client.isS) ? '36px' : '48px'}">
        @for (item of elements; track $index) {
        <ng-template swiperSlide>
            <div class="block"
                 [ngStyle]="{height: (app.client.isM || app.client.isS) ? '36px' : '48px'}">
                <div class="flex flex-justify-center flex-middle p-r-0 p-l-0 height-100"
                     [ngStyle]="{'background-color': item.background_color || 'white'}">
                    <div class="flex flex-middle">
                        <span class="m-r-2 flex"
                              [style.fontSize.px]="20"
                              [ngClass]="'icon-' + item.icon">
                        </span>
                        <span *iCms="'text' of item"
                              class="c1"
                              [ngStyle]="{'color': (item.font_color || 'black')}"
                              [ngClass]="!item.cta_copy ? 'm-r-0' : 'm-r-1'">
                        </span>
                        <div class="pos-relative">
                            <href class="c1 flex flex-middle"
                                  [link]="item.cta_link"
                                  [ngStyle]="{
                                   'color': (item.font_color || 'black'),
                                   'border-color': (item.font_color || 'black')}"
                                  *iCms="'cta_copy' of item">
                            </href>
                            <span class="text-underline"
                                  [ngStyle]="{'background-color': item.font_color || 'black'}"></span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        }
    </carousel>
</ng-template>
}